import React from "react";

function Colors_Compound() {
  return (
    <div>
      <h1>Colors_Compound Component</h1>
      <p>This is the Colors Compound tutorial page content.</p>
    </div>
  );
}

export default Colors_Compound;
